import { useQuery } from "@tanstack/react-query";
import { EtyChangeLog, IGetChangeLogParams } from "../interfaces/change_log";

import api from "./apiClient";

export const useGetChangeLog = (params: IGetChangeLogParams) => {
    const { source, source_id } = params;

    const queryFn = async (): Promise<EtyChangeLog[]> => {
        const res = await api.get(`/change-logs/source/${source}/${source_id}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['change-log', source, source_id],
        queryFn,
        enabled: !!source && !!source_id,
        retry: false,
    });
}